import { POST } from "../../../helpers/restFunction";
export const CreateJobFileUpload = async (data: Object) => {
  const path = `/admin/jobFiles`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
